import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tours-page02',
  templateUrl: './tours-page02.component.html',
  styleUrls: ['./tours-page02.component.css']
})
export class ToursPage02Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
